// @flow
import ApolloClient from 'apollo-boost'
import React from 'react'
import {ApolloProvider} from 'react-apollo'
import ReactDOM from 'react-dom'
import {I18nextProvider} from 'react-i18next'
import {BrowserRouter} from 'react-router-dom'

import App from './App'
import i18n from './i18n'
import ScrollTop from './ScrollTop'

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_API
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <ScrollTop>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </ScrollTop>
    </BrowserRouter>
  </ApolloProvider>,
  (document.getElementById('root')/*: any */)
)

// $FlowFixMe
if (module.hot) {
  // $FlowFixMe
  module.hot.accept()
}



// WEBPACK FOOTER //
// ./src/index.js